<template>
    <div id="map" class="h-full w-full" />
</template>

<script>
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import { onMounted } from "vue";

export default {
  setup(props,context) {
    onMounted(() => {

      mapboxgl.accessToken =
        "pk.eyJ1Ijoia2VyaWdhbiIsImEiOiJjbDNibXIyNDIwMHpvM2NzODN5d2VyMXBuIn0.3472Pt3eUAPbaD7o16V2KQ";

      const map = new mapboxgl.Map({
        container: "map",
        style: "mapbox://styles/kerigan/cks6mdmc418j117p547ct2b0r",
        center: [props.long, props.lat], // starting position [lng, lat]
        zoom: props.zoom, // starting zoom
        attributionControl: false,
      });

      const nav = new mapboxgl.NavigationControl({
          visualizePitch: true
      });
      map.addControl(nav, 'bottom-right');

      const marker = new mapboxgl.Marker()
        .setLngLat([props.long,props.lat])
        .addTo(map);

      map.on('load', () => {
      // TODO: Here we want to load a layer
      // TODO: Here we want to load/setup the popup
      });

    });
    return {};
  },

  props: {
    lat: {
        type: Number,
        default: 0,
    },
    long: {
        type: Number,
        default: 0,
    },
    zoom: {
        type: Number,
        default: 10,
    },
    pins: {
        type: Object,
        default: () => {},
    },
  },

  data() {
    return {
        accessToken: "pk.eyJ1Ijoia2VyaWdhbiIsImEiOiJjazgwOHVuNjYwZWJhM2xucXZpYzh3bGhwIn0.PZrI3RoUM7a7EWb1JUm5nA", // your access token. Needed if you using Mapbox maps
        mapStyle: "mapbox://styles/kerigan/ckgmth6dl1jjc19pdxj6rma2l", // your map style
        coordinates: [this.long,this.lat],
        map: null,
        host: ''
    }
  },
}
</script>
